module.exports = __webpack_public_path__ + "static/media/share.08313b85.webp";